import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";
import download from "../../asset/images/partner-download.svg";
import { toast } from "react-toastify";
import { Frenchisee } from "../../Configuration/Frenchisee_URL";
import UploadIcon from "../../asset/images/uploadImg-white.svg";
import { decryptData, encryptData, handleDownloadDocument } from "../../CommonMethhods/CommonMethods";

function FrenchiseeDocumentDetailsPreview(props) {
    const storeToken = localStorage.getItem("ssoToken");
    let FrenchiseeId = localStorage.getItem("frenchiseeId");
    let navigate = useNavigate();
    let frenchiseeDatails = props.frenchiseeDatails;
    const [showModal, setShowModal] = useState(false);
    const [approveModal, setApproveModal] = useState(false);
    const [rejectionData, setRejectionData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const [mtfBase, setMtfBase] = useState();
    const [bfslSharing, setBfslSharing] = useState();
    const [commonErr, setCommonErr] = useState("");
    const [reasonValid, setReasonValid] = useState(true);


    const onHide = () => {
        setShowModal(false);
        setSelectedFiles([])
    };
    const getRejectionReason = async () => {
        try {
            const getRejection = await axios.get(
                Frenchisee.REJECT_REASONS,

                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getRejection?.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                setRejectionData(dataResp?.data?.rejectReasons);
            } else {
                toast.error(dataResp?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    const rejectedUpdated = async () => {
        
        let rejPayload = {
            id: parseInt(FrenchiseeId),
            status: -2,
            reason: selectedFiles,
        }
        let encyData = encryptData(JSON.stringify(rejPayload))
        try {
            const getStatus = await axios.put(
                Frenchisee.REJECTION_UPDATED,
                `${encyData}`,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getStatus.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                toast.success(dataResp?.data?.message);
                setShowModal(false);
                navigate("/franchisee-onboarding");
            } else {
                setReasonValid(false);
                toast.error(dataResp?.message)
                setShowModal(true);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    useEffect(() => {
        if (!reasonValid) {
            const checkboxes = document.querySelectorAll(".downloadSelect");
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
            setSelectedFiles([]); // Also clear selectedFiles from state
        }
    }, [reasonValid]);

    const getValue = () => {
        let selectedVal = document.getElementById("ap-val");
        let mtfValue = document.getElementById("mtf-data");
        setBfslSharing(document.getElementById("calculate-val").value);
        setSelectedValue(selectedVal.value);
        setMtfBase(mtfValue.value);
        setCommonErr("");
    };

    const approvedStatus = async () => {
        let approvePayload = {
            id: parseInt(FrenchiseeId),
            status: 2,
        }
        let payload = encryptData(JSON.stringify(approvePayload))
        try {
            const getStatus = await axios.put(
                Frenchisee.REJECTION_UPDATED,
                `${payload}`,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getStatus.data);
            let approveRes = JSON.parse(data)
            if (approveRes?.status === 0) {
                toast.success(approveRes?.data?.message);
                // setApproveModal(false)
                navigate("/franchisee-onboarding");
            } else {
                // setApproveModal(true);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };
    const downloadMultiple = (checked = true) => {
        const selectDownload = document.querySelectorAll(".downloadSelect");
        let selectArray = [];
        for (let item of selectDownload) {

            console.log(checked, "checked");
            if (checked) {
                if (item.checked === true) {
                    selectArray.push(parseInt(item.value));
                }
            } else {
                selectArray.push(item.value);
            }
        }
        setSelectedFiles(selectArray);
    };
    const getReason = () => {
        downloadMultiple();
        setReasonValid(true);
    };
    useEffect(() => {
        getRejectionReason();
        setSelectedFiles([]);
    }, []);


    const getApprovalData = async () => {
        let approvePayload = {
            id: parseInt(FrenchiseeId),
            apSharingCommBroking: parseInt(selectedValue),
            bfslSharingCommBroking: selectedValue === "60" ? 40 : selectedValue === "65" ? 35 : selectedValue === "70" ? 30 : "",
            bfslSharingCommMTF: 50,
            apSharingCommMTF: 50,
            mtfBaseRateCommMTF: parseFloat(mtfBase)
        }

        let payload = encryptData(JSON.stringify(approvePayload))

        try {
            const getApproval = await axios.put(
                Frenchisee.UPDATE_APPROVAL,
                payload,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getApproval?.data);
            let dataResp = JSON.parse(data)
            if (dataResp?.status === 0) {
                approvedStatus();
                setRejectionData(dataResp?.data?.rejectReasons);
            } else {
                toast.error(dataResp?.message)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");

        }
    };

    const handleApprovalBtn = () => {
        if (FrenchiseeId?.length > 0 && selectedValue?.length > 0 &&
            bfslSharing?.length > 0 && mtfBase?.length > 0) {
            getApprovalData();
        }else{
            setCommonErr("Please enter all the details");
            // toast.error("Enter all the details")
        }
    };
console.log(frenchiseeDatails, "frenchiseeDatails");

    return (
        <>
            <div className="card-box">
                <div className="card-title">
                    <h2 className="">Document</h2>
                </div>

                <div className="">
                    <div className="">
                        <div className="row imgWrapper">
                            {frenchiseeDatails &&
                                frenchiseeDatails.file?.map((item) => {
                                    return (
                                        <>
                                            <div key={item.id} className='col-md-6 bottom-25'>
                                                <p className='pdf-label'>
                          {item?.type == "1" ? "GST DOCUMENT" : 
                          item?.type == "2" ? "PAN CARD" : 
                          item?.type == "3" ? "EDUCATION CERTIFICATE" : 
                          item?.type == "4" ? "AADHAR FRONT" : 
                          item?.type == "5" ? "AADHAR BACK" : 
                          item?.type == "6" ? "OFFICE ADDRESS DOCUMENT" : 
                          item?.type == "7" ? "MARRIAGE CERTIFICATE" : 
                          item?.type == "8" ? "NAME CHANGE DOCUMENT" : 
                          item?.type == "9" ? "VOTER ID FRONT SIDE" : 
                          item?.type == "10" ? "VOTER ID BACK SIDE" : 
                          item?.type == "11" ? "PASSPORT" : 
                          item?.type == "12" ? "FIRST WITNESS SIGNATURE" : 
                          item?.type == "13" ? "SECOND WITNESS SIGNATURE" : 
                          item?.type == "14" ? "SELFIE UPLOAD"  : 
                          item?.type == "15" ? "CANCELLED CHEQUE" : 
                          item?.type == "16" ? "NSE CERTIFICATE" : 
                          item?.type == "17" ? "BSE CERTIFICATE" : 
                          item?.type == "18" ? "DOs & DONTs CERTIFICATE" : 
                          item?.type == "20" ? "ESIGN BSE AGREEMENT" : 
                          item?.type == "21" ? "ESIGN BSE ANNEXURE" : 
                          item?.type == "22" ? "ESIGN BSE UNDERTAKING" : 
                          item?.type == "23" ? "ESIGN NSE AGREEMENT" : 
                          item?.type == "24" ? "ESIGN NSE ANNEXURE" : 
                          item?.type == "25" ? "ESIGN TERM SHEET": 
                          item?.type == "26" ? "ESIGN INTERNAL AGREEMENT" :
                          item?.type == "27" ? "WELCOME LETTER" : null}</p>

                                                <div className='document-wrapper'>

                                                    {item.fname?.split(".")[1] === 'pdf' ? (
                                                        < iframe src={item.url}
                                                            className="document-pdf partner-down" />
                                                    )
                                                        :
                                                        (
                                                            <img src={item.url} className='document-img'
                                                                alt='document-img' />
                                                        )
                                                    }
                                                    <img src={download} alt="" className="download-img partner-down"
                                                        onClick={() => {
                                                            handleDownloadDocument(item.url)
                                                        }} />
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                {frenchiseeDatails?.statusId === 1 ? (
                    <div className="partner-btn">
                        <div>
                            <button
                                className="appro-btn"
                                type="submit"
                                onClick={() => setApproveModal(true)}
                            >
                                Upload
                                <img
                                    src={UploadIcon}
                                    alt="upload"
                                    className="down-icon cursor-pointer upload-btns"
                                />
                            </button>
                        </div>
                        <div>
                            <button
                                className="rej-btn"
                                type="submit"
                                onClick={() => setShowModal(true)}
                            >
                                Reject
                            </button>
                        </div>
                        <div>
                            <button
                                className="back-btn"
                                type="submit"
                                onClick={() => {
                                    navigate("/franchisee-onboarding");
                                }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <button
                            className="back-btn"
                            type="submit"
                            onClick={() => {
                                navigate("/franchisee-onboarding");
                            }}
                        >
                            Back
                        </button>
                    </div>
                )}
            </div>

            <Modal
                show={approveModal}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model partner-modal-rejection"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">AP Commercials Brokings</h2>
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setApproveModal(false)}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="client-info-status ap-commercial-modal">
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial">
                            <li>
                                <div className="disposition-select">
                                    <label htmlFor="" className="form-text ap-sharing">AP Sharing</label>

                                    <select name="dispositon" id="ap-val" onChange={() => getValue()}>
                                        <option value="default">Select Percent</option>
                                        <option value="60">60%</option>
                                        <option value="65">65%</option>
                                        <option value="70">70%</option>

                                    </select>
                                </div>
                            </li>
                            <li>
                                <div className="disposition-select" >
                                    <label htmlFor="" className="form-text ap-sharing">BFSL Sharing</label>

                                    <input name="partner-source"
                                        disabled
                                        id="calculate-val"
                                        value={selectedValue === "60" ? "40%" : selectedValue === "65" ? "35%" : selectedValue === "70" ? "30%" : ""}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="client-info-status ap-commercial-modal">
                        <h6 className="commercial-head">AP Commercials MTF</h6>
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                            <li>
                                <div className="disposition-select">
                                    <label htmlFor="" className="form-text ap-sharing">MTF BASE Rate</label>
                                    <select name="dispositon"
                                        id="mtf-data" onChange={() => getValue()}>
                                        <option value="default">Select Percent</option>
                                        <option value="12%">12%</option>
                                        <option value="11.50%">11.50%</option>
                                        <option value="11%">11%</option>
                                        <option value="10.50%">10.50%</option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="client-info-status ap-commercial-modal">
                        <ul className="call-web-wrapper disposition-wrapper ap-commercial ap-mtf">
                            <li>
                                <div className="disposition-select">
                                    <label htmlFor="" className="form-text ap-sharing">AP Sharing</label>
                                    <select name="dispositon"
                                        placeholder="select percent">
                                        <option value="default">50%</option>

                                    </select>
                                </div>
                            </li>
                            <li>
                                <div className="disposition-select" >
                                    <label htmlFor="" className="form-text ap-sharing">BFSL Sharing</label>
                                    <select name="partner-source"
                                        placeholder="select the Partner Source">
                                        <option value="default">50%</option>
                                    </select>
                                </div>
                            </li>

                        </ul>
                    <div className="err-handle">
                    <span className="mtf-info">
                    <span className="icon-info-icon info"></span>
                        MTF sharing to be done over and above base rate</span>
                        <span className="common-err">{commonErr}</span>
                        </div>
                    </div>
                    
                    <button
                        type="submit"
                        className="rej-btn"
                        onClick={() => handleApprovalBtn()}
                    >
                        Approve
                    </button>
                </Modal.Body>
            </Modal>
{console.log(reasonValid, "reasonValid")}
            <Modal
                show={showModal}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model partner-modal-rejection"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">Rejection Selection</h2>
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={onHide}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <ul className="partner-ul">
                        {rejectionData &&
                            rejectionData?.map((item) => {
                                return (
                                    <>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="resons"
                                                value={item?.id}
                                                className="downloadSelect"
                                                onClick={() => getReason()}

                                            />
                                            <label>{item?.reason}</label>
                                        </li>
                                    </>
                                );
                            })}
                        {/* </select> */}
                    </ul>
                    <button
                        type="submit"
                        className={selectedFiles.length ? "rej-btn " : "disabled-file"}
                        disabled={selectedFiles.length ? false : true}
                        onClick={() => rejectedUpdated()}
                    >
                        Submit
                    </button>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FrenchiseeDocumentDetailsPreview;
